import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import PageHeader from '../components/common/PageHeader';

const PrivacyPolicyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const breadcrumbs = [
    { label: 'Privacy Policy' }
  ];

  return (
    <>
      <PageHeader 
        title="Privacy Policy" 
        breadcrumbs={breadcrumbs}
      />
      
      <section className="py-16 md:py-24 bg-background">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="prose prose-lg max-w-none"
            >
              <div className="bg-white p-8 rounded-lg shadow-sm mb-8">
                <p className="text-gray-600 mb-8">
                  <strong>Last updated:</strong> {new Date().toLocaleDateString()}
                </p>

                <div className="space-y-8">
                  <section>
                    <h2 className="text-2xl font-bold text-primary mb-4">1. Information We Collect</h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      At Segway Capital, we collect information that you provide directly to us, such as when you create an account, request information about our services, or communicate with us. This may include:
                    </p>
                    <ul className="list-disc ml-6 text-gray-700 space-y-2">
                      <li>Personal identification information (name, email address, phone number)</li>
                      <li>Financial information necessary for investment services</li>
                      <li>Documentation required for regulatory compliance</li>
                      <li>Communication preferences and feedback</li>
                    </ul>
                  </section>

                  <section>
                    <h2 className="text-2xl font-bold text-primary mb-4">2. How We Use Your Information</h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      We use the information we collect to:
                    </p>
                    <ul className="list-disc ml-6 text-gray-700 space-y-2">
                      <li>Provide, maintain, and improve our investment services</li>
                      <li>Process transactions and send related information</li>
                      <li>Send you technical notices, updates, and administrative messages</li>
                      <li>Comply with legal and regulatory requirements</li>
                      <li>Protect against fraudulent or illegal activity</li>
                    </ul>
                  </section>

                  <section>
                    <h2 className="text-2xl font-bold text-primary mb-4">3. Information Sharing and Disclosure</h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except in the following circumstances:
                    </p>
                    <ul className="list-disc ml-6 text-gray-700 space-y-2">
                      <li>To comply with legal obligations or regulatory requirements</li>
                      <li>To service providers who assist us in our operations</li>
                      <li>In connection with a merger, acquisition, or sale of assets</li>
                      <li>To protect the rights, property, or safety of Segway Capital or others</li>
                    </ul>
                  </section>

                  <section>
                    <h2 className="text-2xl font-bold text-primary mb-4">4. Data Security</h2>
                    <p className="text-gray-700 leading-relaxed">
                      We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure.
                    </p>
                  </section>

                  <section>
                    <h2 className="text-2xl font-bold text-primary mb-4">5. Your Rights</h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      You have the right to:
                    </p>
                    <ul className="list-disc ml-6 text-gray-700 space-y-2">
                      <li>Access and update your personal information</li>
                      <li>Request deletion of your personal information</li>
                      <li>Object to the processing of your personal information</li>
                      <li>Request data portability</li>
                    </ul>
                  </section>

                  <section>
                    <h2 className="text-2xl font-bold text-primary mb-4">6. Contact Us</h2>
                    <p className="text-gray-700 leading-relaxed">
                      If you have any questions about this Privacy Policy, please contact us at:
                    </p>
                    <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                      <p className="text-gray-700">
                        <strong>Segway Capital</strong><br />
                        Email: info@segwaycapital.com<br />
                        Phone: +44 7468 903587
                      </p>
                    </div>
                  </section>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicyPage; 